import { useAtomValue } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { Scopes } from '$authentication/useHasPermission/constants';
import { useHasPermission } from '$authentication/useHasPermission/useHasPermission';
import { useInteractionParams } from '../hooks/useInteractionParams';

export const SHOW_GLOBAL_INTERACTIONS = 'showGlobalInteractions';

/**
 * Atom to store all preferences.
 * Synchronized with `localStorage` via `atomWithStorage`.
 *
 */
export const globalInteractions = atomWithStorage(
  SHOW_GLOBAL_INTERACTIONS,
  false,
);

export const useGlobalInteractionsEnabled = () => {
  const { interactionType } = useInteractionParams();
  const { hasPermission: hasInteractionsReadPermission } = useHasPermission({
    roles: ['ADMIN'],
    scopes: [Scopes.INTERACTIONS_READ],
  });
  const isToggleTurnedOn = useAtomValue(globalInteractions);

  const isOnGiaPage = !!interactionType;

  return isOnGiaPage && isToggleTurnedOn && hasInteractionsReadPermission;
};
